import { render, staticRenderFns } from "./edit-product-feature.vue?vue&type=template&id=6ea0d8b2&scoped=true&"
import script from "./edit-product-feature.vue?vue&type=script&lang=js&"
export * from "./edit-product-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea0d8b2",
  null
  
)

export default component.exports